export default __webpack_public_path__ + "static/default-04912480ca774f665a98c34a3354be10.jpg";